import React, { useState } from 'react'
import { Button } from '../../lib/ui/button'
import { Toaster } from '../../lib/ui/toast'
import { DocumentTextIcon } from '@heroicons/react/24/outline'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../../lib/ui/dialog'
import DropzoneResumeUpload from './DropzoneResumeUpload'

const NewResumeModal = () => {
  const [open, setOpen] = useState(false)

  const toggleOpen = () => {
    setOpen(!open)
  }

  return (
    <Dialog
      open={open}
      onOpenChange={toggleOpen}
      className="!w-auto rounded-2xl lg:max-w-[37rem] xl:max-w-[37rem]"
    >
      <DialogTrigger asChild className="cursor-pointer">
        <Button variant="link">Upload a resume for this candidate</Button>
      </DialogTrigger>
      <DialogContent
        className="font-roboto lg:max-w-3xl xl:max-w-5xl"
        variant="default"
        dialogCloseClass="text-black"
      >
        <DialogHeader>
          <DialogTitle className="text-left" asChild>
            <h2 className="text-2xl">
              Upload a Resume
              <DocumentTextIcon className="ml-2 inline w-6" />
            </h2>
          </DialogTitle>
        </DialogHeader>
        <DropzoneResumeUpload />
      </DialogContent>
      <Toaster />
    </Dialog>
  )
}
export default NewResumeModal
